import { ProductionGeneration, ProductionStage, FlockStatus } from "../Flock";
import { BreedAM } from "./BreedAM";
import { FarmingMethodAM } from "./FarmingMethodAM";

export interface FlockOptionAM {
	id: string;
	flockNumber: string | null;
	nickname: string | null;
	status: FlockStatus;
	breed?: BreedAM;

	farmId: string;
	farmName: string | null;

	farmingMethod?: FarmingMethodAM;
	generation?: ProductionGeneration;
	stage?: ProductionStage;
}

export enum ChartSerie {
	HenCount = "HenCount",
	NormalEggCount = "NormalEggCount",
	FloorEggCount = "FloorEggCount",
	TotalEggCount = "TotalEggCount",
	FloorEggPercentage = "FloorEggPercentage",
	AverageEggWeight = "AverageEggWeight",
	DeadCount = "DeadCount",
	AverageHenWeight = "AverageHenWeight",
	WaterMeterReading = "WaterMeterReading",
	WaterConsumption = "WaterConsumption",
	WaterConsumptionPerHen = "WaterConsumptionPerHen",
	FodderConsumption = "FodderConsumption",
	FodderConsumptionPerHen = "FodderConsumptionPerHen",
	Temperature = "Temperature",
	Humidity = "Humidity",
	Ammonia = "Ammonia",
	EggPerHenPercentage = "EggPerHenPercentage",
	FodderConsumptionPerEggWeight = "FodderConsumptionPerEggWeight",
	WaterConsumptionPerEggWeight = "WaterConsumptionPerEggWeight",
	AGradeEggPercentage = "AGradeEggPercentage",
	CumulativeEggWeight = "CumulativeEggWeight",
	EggsPerHousedHen = "EggsPerHousedHen",
	MortalityRate = "MortalityRate",
}

export enum ChartSerieForRearingHouse {
	HenCount = "HenCount",
	DeadCount = "DeadCount",
	AverageHenWeight = "AverageHenWeight",
	WaterMeterReading = "WaterMeterReading",
	WaterConsumption = "WaterConsumption",
	WaterConsumptionPerHen = "WaterConsumptionPerHen",
	FodderConsumption = "FodderConsumption",
	FodderConsumptionPerHen = "FodderConsumptionPerHen",
	Temperature = "Temperature",
	Humidity = "Humidity",
	Ammonia = "Ammonia",
	MortalityRate = "MortalityRate",
}

export enum ChartSerieForLayingHouseOnly {
	NormalEggCount = "NormalEggCount",
	FloorEggCount = "FloorEggCount",
	TotalEggCount = "TotalEggCount",
	FloorEggPercentage = "FloorEggPercentage",
	AverageEggWeight = "AverageEggWeight",
	EggPerHenPercentage = "EggPerHenPercentage",
	FodderConsumptionPerEggWeight = "FodderConsumptionPerEggWeight",
	WaterConsumptionPerEggWeight = "WaterConsumptionPerEggWeight",
	AGradeEggPercentage = "AGradeEggPercentage",
	CumulativeEggWeight = "CumulativeEggWeight",
	EggsPerHousedHen = "EggsPerHousedHen",
}

export interface FlockChartDataAM {
	flockId: string;
	farmId: string;
	measureValues: {
		filter: ChartSerie;
		values: {
			weekNumber: number;
			value: number;
			date: string;
		}[];
	}[];
}
